import { createAction } from '@reduxjs/toolkit';

import { moduleName } from '../constants';
import type { ChildrenOrg } from './types';

export const addChildren = createAction<Array<ChildrenOrg>>(
  `${moduleName}/ADD_CHILDREN`,
);

export const ADD_CHILDREN = addChildren.type;
